import { Banner, Button, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

function ReviewBanner({ linkUrl }: { linkUrl: string }) {
  const { t } = useTranslation(["review"]);

  return (
    <Banner dismissable className="gap-x-xs mt-sm">
      <Typography step="-1" weight="bold" as="p">
        {t("review:banner.private.text")}
      </Typography>
      <Button
        shape="soft"
        intent="secondary"
        size="small"
        as={Link}
        to={linkUrl}
        reloadDocument
      >
        {t("review:banner.private.giveMyOpinion")}
      </Button>
    </Banner>
  );
}

export default ReviewBanner;
